import { PATH_APP } from '@/routes/paths';
import { atLeastManager, allStaff, atLeastAdmin, Role } from '@/models/common';
import { CalendarIcon } from '../../../common/icons/CalendarIcon';
import { AutopayIcon } from '../../../common/icons/AutopayIcon';
import { ClientIcon } from '../../../common/icons/ClientIcon';
import { CardIcon } from '../../../common/icons/CardIcon';
import { PricesIcon } from '../../../common/icons/PricesIcon';
import { PromotionsNavIcon } from '../../../common/icons/PercentIcon';
import { ReportsIcon } from '../../../common/icons/ReportsIcon';
import { RetailIcon } from '../../../common/icons/RetailIcon';
import { SlotIcon } from '../../../common/icons/SlotsIcon';
import { TherapistIcon } from '../../../common/icons/TherapistIcon';
import { ProductIcon } from '../../../common/icons/ProductIcon';
import { CreditsIcon } from '../../../common/icons/CreditsIcon';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { Product2Icon } from '@/common/icons/Product2Icon';
import { AccessTime } from '@mui/icons-material';

export type NavHeaderGroup = {
  display: string;
  items: NavHeaderItem[];
};

export type NavHeaderItem = {
  display: string;
  href: string;
  external?: boolean;
  roles: Role[];
  icon?: React.ReactNode;
};

const sidebarObj: NavHeaderGroup[] = [
  {
    display: 'Studio',
    items: [
      {
        display: 'Appointments',
        href: PATH_APP.appointment.root,
        roles: allStaff(),
        icon: <CalendarIcon />
      },
      {
        display: 'Clients',
        href: PATH_APP.customer.root,
        roles: allStaff(),
        icon: <ClientIcon />
      },
      {
        display: 'Retail',
        href: PATH_APP.retail3.root,
        roles: allStaff(),
        icon: <RetailIcon />
      },
      {
        display: 'Reports',
        href: PATH_APP.reports.root,
        roles: allStaff(),
        icon: <ReportsIcon />
      }
    ]
  },
  {
    display: 'Settings',
    items: [
      {
        display: 'Autopays',
        href: PATH_APP.studiodashboard.root,
        roles: allStaff(),
        icon: <AutopayIcon />
      },
      {
        display: 'Promotions',
        href: PATH_APP.promotions.root,
        roles: atLeastManager(),
        icon: <PromotionsNavIcon />
      },
      {
        display: 'Gift Cards',
        href: PATH_APP.giftCards.root,
        roles: allStaff(),
        icon: <CardIcon />
      },
      {
        display: 'Staff',
        href: PATH_APP.staffmgmt.root,
        roles: atLeastManager(),
        icon: <PeopleOutlineIcon />
      },
      {
        display: 'Therapists',
        href: PATH_APP.therapist.root,
        roles: atLeastManager(),
        icon: <TherapistIcon />
      },
      {
        display: 'Shift Lead',
        href: PATH_APP.shiftLead.root,
        roles: allStaff(),
        icon: <AccessTime />
      },
      {
        display: 'Slots',
        href: PATH_APP.appointment.slotItems,
        roles: atLeastManager(),
        icon: <SlotIcon />
      },
      {
        display: 'Prices',
        href: PATH_APP.categorized.root,
        roles: allStaff(),
        icon: <PricesIcon />
      }
    ]
  },
  {
    display: 'Admin',
    items: [
      {
        display: 'Products',
        href: PATH_APP.product.root,
        roles: atLeastAdmin(),
        icon: <ProductIcon />
      },
      {
        display: 'Products v2',
        href: PATH_APP.product2.root,
        roles: atLeastAdmin(),
        icon: <Product2Icon />
      },
      {
        display: 'Credits',
        href: PATH_APP.credit.root,
        roles: atLeastAdmin(),
        icon: <CreditsIcon />
      }
    ]
  }
];

export default sidebarObj;
